//#region import libraries
import React, { useEffect } from "react";

//redux
import { useDispatch, useSelector } from "react-redux";
import { selectRowsPerPage, setCurrentPage, setRowsPerPage } from "_redux/slices/timeline/timeline-control";
import { selectUsedTheme } from '_redux/slices/timeline/theme';
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";
//#endregion

const RowsPerPage = () => {

    //#region redux
    const dispatch = useDispatch()
    const rowsPerPage = useSelector(selectRowsPerPage)
    const usedTheme = useSelector(selectUsedTheme);
    const dbUser = useSelector(selectFirebaseInfo);
    //#endregion

    // Handle change in rows per page
    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = +e.target.value;
        dispatch(setRowsPerPage(newRowsPerPage));
        dispatch(setCurrentPage(1));
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                    Employee List
                </span>
                <select value={rowsPerPage} onChange={handleRowsPerPageChange} style={{
                    minWidth: '40px',
                    padding: '3px 6px',
                    borderRadius: '4px',
                    fontSize: '14px',
                    backgroundColor: usedTheme.BACKGROUND_COLOR,
                    borderColor: usedTheme.BORDER_COLOR,
                    color: usedTheme.TEXT_COLOR
                }} >
                    <option value="5">05</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                </select>
            </div>
            <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                Select the number of employees displayed in the list
            </span>
        </div>
    )
}

export default RowsPerPage
